import React from 'react'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

function cn(...inputs: (string | undefined | null | boolean)[]) {
  return twMerge(clsx(inputs))
}

interface StatCardProps {
  title: string
  value: string
  subtitle?: string
  icon: React.ComponentType<{ className?: string }>
  trend?: {
    value: number
    label?: string
  }
  iconColor?: string
  iconBg?: string
}

export function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  iconColor = 'text-indigo-600',
  iconBg = 'bg-indigo-50',
}: StatCardProps) {
  const trendPositive = trend && trend.value > 0
  const trendNegative = trend && trend.value < 0
  const trendNeutral = trend && trend.value === 0

  return (
    <Card className="card-hover">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-500 truncate">{title}</p>
            <p className="mt-2 text-2xl font-bold text-gray-900 truncate">{value}</p>
            {subtitle && (
              <p className="mt-1 text-xs text-gray-500 truncate">{subtitle}</p>
            )}
            {trend && (
              <div className="mt-2 flex items-center gap-1">
                {trendPositive && (
                  <>
                    <TrendingUp className="h-3.5 w-3.5 text-green-500" />
                    <span className="text-xs font-medium text-green-600">
                      +{trend.value.toFixed(1)}%
                    </span>
                  </>
                )}
                {trendNegative && (
                  <>
                    <TrendingDown className="h-3.5 w-3.5 text-red-500" />
                    <span className="text-xs font-medium text-red-600">
                      {trend.value.toFixed(1)}%
                    </span>
                  </>
                )}
                {trendNeutral && (
                  <>
                    <Minus className="h-3.5 w-3.5 text-gray-400" />
                    <span className="text-xs font-medium text-gray-500">0%</span>
                  </>
                )}
                {trend.label && (
                  <span className="text-xs text-gray-400">{trend.label}</span>
                )}
              </div>
            )}
          </div>
          <div className={cn('p-3 rounded-xl shrink-0 ml-4', iconBg)}>
            <Icon className={cn('h-5 w-5', iconColor)} />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
